import React from 'react';

export default function FileAnswer() {
  return <div className='ml-6 flex flex-col gap-4'>Maximum file size: 4MB</div>; // to translate
}
